import React, { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import successGif from "../../../assets/success.gif";
import "./EditBankModal.scss"; // Assuming you have a CSS file for styles
const EditBankModal = ({ show, bank, onClose, onSave }) => {
  const [formData, setFormData] = useState({
    name: "",
    iban: "",
    bic: "",
    rib: "",
  });

  const [showSuccess, setShowSuccess] = useState(false);

  useEffect(() => {
    if (bank && show) {
      setFormData({
        name: bank.name || "",
        iban: bank.iban || "",
        bic: bank.bic || "",
        rib: bank.rib || "",
      });
      setShowSuccess(false); // reset success state when reopened
    }
  }, [bank, show]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await onSave(bank._id, formData);
      setShowSuccess(true);

      // Delay the modal closing
      setTimeout(() => {
        onClose(); // parent will hide modal
      }, 2000);
    } catch (err) {
      console.error("Erreur de mise à jour :", err);
    }
  };

  return (
    <Modal
      show={show}
      onHide={onClose}
      centered
      backdrop="static"
      animation={true}
    >
      {/* Hide header on success */}
      {!showSuccess && (
        <Modal.Header closeButton>
          <Modal.Title>Modifier la banque</Modal.Title>
        </Modal.Header>
      )}

      <Modal.Body>
        {showSuccess ? (
          <div className="text-center animate__animated animate__fadeIn">
            <img
              src={successGif}
              alt="Success"
              style={{ width: "100px", height: "100px" }}
              className="mb-3"
            />
            <h5 className="text-success">Modifié avec succès !</h5>
          </div>
        ) : (
          <Form
            onSubmit={handleSubmit}
            className="animate__animated animate__fadeIn"
          >
            <Form.Group controlId="bankName" className="mb-3">
              <Form.Label>Nom de la banque</Form.Label>
              <Form.Control
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
              />
            </Form.Group>

            <Form.Group controlId="iban" className="mb-3">
              <Form.Label>IBAN</Form.Label>
              <Form.Control
                type="text"
                name="iban"
                value={formData.iban}
                onChange={handleChange}
              />
            </Form.Group>

            <Form.Group controlId="bic" className="mb-3">
              <Form.Label>BIC</Form.Label>
              <Form.Control
                type="text"
                name="bic"
                value={formData.bic}
                onChange={handleChange}
              />
            </Form.Group>

            <Form.Group controlId="rib" className="mb-3">
              <Form.Label>RIB</Form.Label>
              <Form.Control
                type="text"
                name="rib"
                value={formData.rib}
                onChange={handleChange}
              />
            </Form.Group>

            <div className="d-flex justify-content-end">
              <Button variant="secondary" onClick={onClose} className="me-2">
                Annuler
              </Button>
              <Button variant="primary" type="submit">
                Enregistrer
              </Button>
            </div>
          </Form>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default EditBankModal;
